// StatePage.jsx
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { MapContainer, TileLayer, Marker, Popup, GeoJSON } from "react-leaflet";
import axios from "axios";
import BreweryItem from "../components/BreweryItem";
import { Icon } from "leaflet";
import getState from "../helpers/getState";
import "leaflet/dist/leaflet.css";
import FitBounds from "../helpers/FitBounds"; // Import the FitBounds component

const markerIcon = new Icon({
    iconUrl: "/beermug.svg",
    iconSize: [32, 32],
});

const StatePage = () => {
    const { stateName } = useParams();
    const [breweries, setBreweries] = useState([]);
    const [selectedBreweryId, setSelectedBreweryId] = useState(null);
    const [selectedState, setSelectedState] = useState(null);

    useEffect(() => {
        const fetchBreweries = async () => {
            try {
                const url = `https://api.openbrewerydb.org/v1/breweries?by_state=${encodeURIComponent(
                    stateName
                )}`;
                console.log({ url });
                const response = await axios.get(url);
                setBreweries(response.data);
            } catch (error) {
                console.error("Error fetching breweries:", error);
            }
        };
        fetchBreweries();
        setSelectedState(getState(stateName)); // Assume getState returns valid GeoJSON
    }, [stateName]);

    // When a marker is clicked, move that brewery’s card to the top and highlight it.
    const handleMarkerClick = id => {
        setSelectedBreweryId(id);
        setBreweries(prev => {
            const clickedBrewery = prev.find(brewery => brewery.id === id);
            const others = prev.filter(brewery => brewery.id !== id);
            return [clickedBrewery, ...others];
        });
    };

    return (
        <div>
            <h2 className="mb-3">{stateName} Breweries</h2>
            <div className="d-flex flex-wrap">
                {/* Map */}
                <div className="map-section">
                    <MapContainer
                        style={{ height: "500px", width: "100%" }}
                        center={[37.8, -96]}
                        zoom={5}
                    >
                        <TileLayer
                            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            attribution="&copy; OpenStreetMap contributors"
                        />
                        {breweries.map(brewery =>
                            brewery.latitude && brewery.longitude ? (
                                <Marker
                                    icon={markerIcon}
                                    key={brewery.id}
                                    position={[
                                        brewery.latitude,
                                        brewery.longitude,
                                    ]}
                                    eventHandlers={{
                                        click: () =>
                                            handleMarkerClick(brewery.id),
                                    }}
                                >
                                    <Popup>{brewery.name}</Popup>
                                </Marker>
                            ) : null
                        )}
                        {selectedState && (
                            <>
                                <GeoJSON
                                    data={selectedState}
                                    style={{
                                        fillColor: "aquamarine",
                                        weight: 1,
                                        color: "blue",
                                    }}
                                />
                                {/* Use the FitBounds component to zoom to the polygon */}
                                <FitBounds geoJsonData={selectedState} />
                            </>
                        )}
                    </MapContainer>
                </div>
                {/* Breweries List */}
                <div className="list-section">
                    <ul className="list-group">
                        {breweries.map(brewery => (
                            <BreweryItem
                                key={brewery.id}
                                brewery={brewery}
                                isSelected={brewery.id === selectedBreweryId}
                            />
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default StatePage;
